<ng-container *transloco="let t">
  <span class="ui-item-link admin-action language-selector">
    <div #dropdown="ngbDropdown" ngbDropdown [autoClose]="true" placement="bottom-right">
      <pxw-button ngbDropdownToggle [color]="buttonColor()" [rounded]="true">
        <pxw-icon icon="share" />
      </pxw-button>
      <div ngbDropdownMenu style="margin-top: 0.5em">
        <pxw-button
          ngbDropdownItem
          appareance="link"
          color="blue"
          [href]="whatsappShareLink()"
          [target]="whatsappLinkHttpTarget()"
        >
          <pxw-icon icon="whatsapp" />
          {{ t('shareButton.whatsapp') }}
        </pxw-button>
        <div class="dropdown-divider"></div>
        <pxw-button
          ngbDropdownItem
          appareance="link"
          color="blue"
          [cdkCopyToClipboard]="url()"
          (cdkCopyToClipboardCopied)="onCopiedSuccess()"
        >
          <pxw-icon icon="copy" />
          {{ t('shareButton.copy') }}
        </pxw-button>
      </div>
      <div class="ui-dropdown__backdrop" [hidden]="!dropdown.isOpen()"></div>
    </div>
  </span>
</ng-container>
